module.exports = "/_next/static/images/bitcoin_shade-c608f55963c6ab130a5535a3ea405d91.png";